var _rect, _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.9525,
    height: 23.9525,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3412 21.5373L9.51181 22.096L10.3412 21.5373ZM13.6588 21.5373L14.4882 22.096L13.6588 21.5373ZM14.9746 19.5839L14.1452 19.0253L14.9746 19.5839ZM9.02544 19.5839L8.19604 20.1426L9.02544 19.5839ZM3 6.14258C3 4.48572 4.34315 3.14258 6 3.14258V1.14258C3.23858 1.14258 1 3.38115 1 6.14258H3ZM3 15.1426V6.14258H1V15.1426H3ZM6 18.1426C4.34315 18.1426 3 16.7994 3 15.1426H1C1 17.904 3.23858 20.1426 6 20.1426V18.1426ZM8.19604 18.1426H6V20.1426H8.19604V18.1426ZM11.1706 20.9787L9.85483 19.0253L8.19604 20.1426L9.51181 22.096L11.1706 20.9787ZM12.8294 20.9787C12.433 21.5671 11.567 21.5671 11.1706 20.9787L9.51181 22.096C10.7009 23.8613 13.2991 23.8613 14.4882 22.096L12.8294 20.9787ZM14.1452 19.0253L12.8294 20.9787L14.4882 22.096L15.804 20.1426L14.1452 19.0253ZM18 18.1426H15.804V20.1426H18V18.1426ZM21 15.1426C21 16.7994 19.6569 18.1426 18 18.1426V20.1426C20.7614 20.1426 23 17.904 23 15.1426H21ZM21 6.14258V15.1426H23V6.14258H21ZM18 3.14258C19.6569 3.14258 21 4.48572 21 6.14258H23C23 3.38115 20.7614 1.14258 18 1.14258V3.14258ZM6 3.14258H18V1.14258H6V3.14258ZM15.804 20.1426H15.804V18.1426C15.1386 18.1426 14.5169 18.4734 14.1452 19.0253L15.804 20.1426ZM8.19604 20.1426L9.85483 19.0253C9.48314 18.4734 8.86137 18.1426 8.19604 18.1426V20.1426Z",
    fill: "#303C54"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 11,
    r: 1,
    fill: "#303C54"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 1,
    fill: "#303C54"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 11,
    r: 1,
    fill: "#303C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.9800eeb5b6c690312d24f3af38607664.svg";
export { ForwardRef as ReactComponent };